import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { MenuSearch } from '../components/menu-search/MenuSearch';
import { useMenuSearch } from '../hooks/useMenuSearch';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
const MenuSearchContainer = ({ queryValue, brandsParentLink, categoriesParentLink, suggestionsParentLink, }) => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(queryValue);
    const { menuSearchItemGrouping } = useMenuSearch({
        searchTerm: searchValue,
        suggestionsParentLink,
        brandsParentLink,
        categoriesParentLink,
    });
    const setSearchTerm = (searchTerm) => {
        if (searchTerm) {
            dispatch(analyticsActions.createFetchWithoutProductsAction(searchTerm));
        }
        setSearchValue(searchTerm);
    };
    const createAdobeAnalyticsSetSearchTermAction = (searchterm) => {
        dispatch(analyticsActions.createAdobeAnalyticsSetSearchTermAction(searchterm));
    };
    return (_jsx(MenuSearch, { createAdobeAnalyticsSetSearchTermAction: createAdobeAnalyticsSetSearchTermAction, menuSearchItemGrouping: menuSearchItemGrouping, setSearchValue: setSearchTerm, suggestionsParentLink: suggestionsParentLink, searchValue: searchValue }));
};
export default MenuSearchContainer;
